import React from 'react';

import { Footer, Header } from '../components';

import styles from './Frame.module.scss';
import classNames from 'classnames';

const Frame = ({ children }: React.PropsWithChildren) => {
  return (
    <div className={styles.frame}>
      <Header />
      <main className={classNames(styles.main, 'container')}>{children}</main>
      <Footer />
    </div>
  );
};

export default Frame;
